import ds from './src/Datasource';
import win from './src/Window';
import GLOBAL from './src/Global';
import webapi from './src/Webapi';
import vue from './src/V3Vue';
import v3platform from './src/v3platform';
import res from './src/Resource';
import mobile from './src/Mobile';

export default {
  ds,
  win,
  page:win,
  GLOBAL,
  webapi,
  vue,
  v3platform,
  res,
  mobile
};


// WEBPACK FOOTER //
// ./index.js